// pages/admins/permissions/PermissionSummaryHeader.jsx
//
// Section A from the redesign brief: a strong, scannable summary card for
// the selected user -- name, role, unit/department, ID/email, Active/
// Inactive badge, plus Total/Allowed/Denied/Overrides chips. Refactor of
// AccessManagementUsersPage.jsx's own former `aup-hero` + `aup-access-
// summary` markup -- same data (`user`, `accessSummary`), same badge
// classes (`unit-status`), nothing new fetched or computed here.
import React from "react";
import { Badge } from "react-bootstrap";

function initialsFor(name) {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  return (parts[0][0] + (parts[1]?.[0] || "")).toUpperCase();
}

export default function PermissionSummaryHeader({ user, roleColor, accessSummary }) {
  return (
    <div className="pm-summary-header">
      <div className="aup-hero">
        <div className="aup-hero-avatar" style={{ background: roleColor.bg, color: roleColor.fg }}>
          {initialsFor(user.name)}
        </div>
        <div className="aup-hero-text">
          <span className="aup-hero-role-badge" style={{ background: roleColor.bg, color: roleColor.fg }}>
            {user.roleName || "—"}
          </span>
          <h3>{user.name}</h3>
          <div className="aup-hero-meta">
            {user.unitName != null && <span>Unit: {user.unitName}</span>}
            {user.departmentName != null && <span>{user.departmentName}</span>}
            {user.designationName != null && <span>{user.designationName}</span>}
            <span>{user.email}</span>
            <span>User ID {user.id ?? "—"}</span>
            {user.employeeCode != null && <span>{user.employeeCode}</span>}
          </div>
        </div>
        <Badge bg={null} className={user.isActive ? "unit-status" : "unit-status unit-status-inactive"}>
          {user.isActive ? "Active" : "Inactive"}
        </Badge>
      </div>

      {accessSummary && (
        <div className="aup-access-summary">
          <div className="aup-summary-chip">
            <i className="fa-solid fa-key" aria-hidden="true"></i>
            {accessSummary.totalPermissions} Total Permission{accessSummary.totalPermissions === 1 ? "" : "s"}
          </div>
          <div className="aup-summary-chip aup-summary-chip-success">
            <i className="fa-solid fa-circle-check" aria-hidden="true"></i>
            {accessSummary.effectiveAllowed} Effective Allowed
          </div>
          <div className="aup-summary-chip aup-summary-chip-danger">
            <i className="fa-solid fa-circle-xmark" aria-hidden="true"></i>
            {accessSummary.effectiveDenied} Effective Denied
          </div>
          <div className="aup-summary-chip aup-summary-chip-override">
            <i className="fa-solid fa-user-pen" aria-hidden="true"></i>
            {accessSummary.userOverrides} User Override{accessSummary.userOverrides === 1 ? "" : "s"}
          </div>
        </div>
      )}
    </div>
  );
}
